// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"744":"c8c8e91695339db8","946":"3832d5f1d6519c85","973":"1322f2318bf1d55b"}[chunkId] + ".js";
};